export default Object.freeze({
	live: [
		{
			description:
				"Old bridge (© Arseniy Chebynkin / DerDenniis / Wallpaper Engine)",
			id: "Live1",
			thumbnail:
				"https://limestart-assets.retiehe.com/wallpapers/Live1.webp",
		},
		{
			description: "Cabin by the lake (© HoHoHO / Wallpaper Engine)",
			id: "Live2",
			thumbnail:
				"https://limestart-assets.retiehe.com/wallpapers/Live2.webp",
		},
		{
			description:
				"Snow Evening (© Evgeny Lushpin / Kesler / Wallpaper Engine)",
			id: "Live3",
			thumbnail:
				"https://limestart-assets.retiehe.com/wallpapers/Live3.webp",
		},
		{
			description: "We Wish You a Merry Christmas (© Nimia)",
			id: "Live4",
			thumbnail:
				"https://limestart-assets.retiehe.com/wallpapers/Live4.webp",
		},
	],
	static: [
		{
			description:
				"孚日山脉的针叶林，法国 (© Radomir Jakubowski / Minden Pictures)",
			fallbackUrl:
				"https://limestart-assets.retiehe.com/wallpapers/Default3.jpg",
			id: "Default3",
			thumbnail:
				"https://limestart-assets.retiehe.com/wallpapers/Default3_Pre.jpg",
			url: "https://cn.bing.com/th?id=OHR.SunbeamsForest_ZH-CN5358008117_1920x1080.jpg&rf=LaDigue_1920x1080.jpg&pid=hp",
		},
		{
			description:
				"东库特尼的埃尔克河，加拿大不列颠哥伦比亚省 (© Carson Ganci / First Light / age fotostock)",
			id: "Default1",
			thumbnail:
				"https://limestart-assets.retiehe.com/wallpapers/Default1_Pre.jpg",
			url: "https://limestart-assets.retiehe.com/wallpapers/Default1.jpg",
		},
		{
			description:
				"瓦尔内明德的灯塔，德国梅克伦堡-前波美拉尼亚州罗斯托克市 (© Sandra Kreuzinger / Moment Open / Getty Images)",
			id: "Default2",
			thumbnail:
				"https://limestart-assets.retiehe.com/wallpapers/Default2_Pre.jpg",
			url: "https://limestart-assets.retiehe.com/wallpapers/Default2.jpg",
		},
		{
			description: "布莱顿码头，阿德莱德布莱顿 (© Darryl Leach / Alamy)",
			fallbackUrl:
				"https://limestart-assets.retiehe.com/wallpapers/Default4.jpg",
			id: "Default4",
			thumbnail:
				"https://limestart-assets.retiehe.com/wallpapers/Default4_Pre.jpg",
			url: "https://cn.bing.com/th?id=OHR.BrightonJetty_ZH-CN1526526038_1920x1080.jpg&rf=LaDigue_1920x1080.jpg&pid=hp",
		},
		{
			description:
				"Loughrigg Tarn的日出，英国英格兰湖区安布尔塞德 (© John Finney photography / Getty Images)",
			fallbackUrl:
				"https://limestart-assets.retiehe.com/wallpapers/Default5.jpg",
			id: "Default5",
			thumbnail:
				"https://limestart-assets.retiehe.com/wallpapers/Default5_Pre.jpg",
			url: "https://cn.bing.com/th?id=OHR.LoughriggTarn_ZH-CN1404327665_1920x1080.jpg&rf=LaDigue_1920x1080.jpg&pid=hp",
		},
		{
			description:
				"缅因州达马里斯科塔地区的佩马基德灯塔 (© Tom Whitney / Adobe Stock)",
			fallbackUrl:
				"https://limestart-assets.retiehe.com/wallpapers/Default6.jpg",
			id: "Default6",
			thumbnail:
				"https://limestart-assets.retiehe.com/wallpapers/Default6_Pre.jpg",
			url: "https://cn.bing.com/th?id=OHR.MetamorphicRocks_ZH-CN9753251368_1920x1080.jpg&rf=LaDigue_1920x1080.jpg&pid=hp",
		},
		{
			description:
				"帕卢斯的农田，华盛顿州，美国 (© EJ-J / Getty Images)",
			id: "Default-PalouseHills",
			thumbnail:
				"https://limestart-assets.retiehe.com/wallpapers/Default-PalouseHills-Thumbnail.jpeg",
			url: "https://cn.bing.com/th?id=OHR.PalouseHills_ZH-CN6864015897_1920x1080.jpg&rf=LaDigue_1920x1080.jpg&pid=hp",
		},
		{
			description:
				"旧西街区，阿姆斯特丹 ，荷兰 (© George Pachantouris / Getty Images)",
			id: "Default-BlueAmsterdam",
			thumbnail:
				"https://limestart-assets.retiehe.com/wallpapers/Default-BlueAmsterdam-Thumbnail.jpeg",
			url: "https://cn.bing.com/th?id=OHR.BlueAmsterdam_ZH-CN0483591394_1920x1080.jpg&rf=LaDigue_1920x1080.jpg&pid=hp",
		},
		{
			description:
				"特卡波湖沿岸的鲁冰花，南岛，新西兰 (© Jeffrey Lewis / Tandem Stills + Motion)",
			id: "Default-RussellLupines",
			thumbnail:
				"https://limestart-assets.retiehe.com/wallpapers/Default-RussellLupines-Thumbnail.jpeg",
			url: "https://cn.bing.com/th?id=OHR.RussellLupines_ZH-CN8552113285_1920x1080.jpg&rf=LaDigue_1920x1080.jpg&pid=hp",
		},
		{
			description:
				"西南阿连特茹和维森廷海岸自然公园上空的银河，葡萄牙 (© Daniel Garrido / Getty Images)",
			id: "Default-MilkyWayPortugal",
			thumbnail:
				"https://limestart-assets.retiehe.com/wallpapers/Default-MilkyWayPortugal-Thumbnail.jpeg",
			url: "https://cn.bing.com/th?id=OHR.MilkyWayPortugal_ZH-CN8878883229_1920x1080.jpg&rf=LaDigue_1920x1080.jpg&pid=hp",
		},
		{
			description:
				"睡在雪地里的赤狐，阿布鲁佐，意大利 (© marco vancini / 500px / Getty Images)",
			id: "Default-SleepingFox",
			thumbnail:
				"https://limestart-assets.retiehe.com/wallpapers/Default-SleepingFox-Thumbnail.jpeg",
			url: "https://cn.bing.com/th?id=OHR.SleepingFox_ZH-CN2622967726_1920x1080.jpg&rf=LaDigue_1920x1080.jpg&pid=hp",
		},
		{
			description: "胡德山，俄勒冈州，美国 (© Inigo Cia / Getty Images)",
			id: "Default-MtHoodOregon",
			thumbnail:
				"https://limestart-assets.retiehe.com/wallpapers/Default-MtHoodOregon-Thumbnail.jpeg",
			url: "https://cn.bing.com/th?id=OHR.MtHoodOregon_ZH-CN6068357532_1920x1080.jpg&rf=LaDigue_1920x1080.jpg&pid=hp",
		},
		{
			description: "巴西亚马逊上空巨大的砧状云 (© NASA)",
			id: "Default-AmazonClouds",
			thumbnail:
				"https://limestart-assets.retiehe.com/wallpapers/Default-AmazonClouds-Thumbnail.jpeg",
			url: "https://cn.bing.com/th?id=OHR.AmazonClouds_ZH-CN0578911147_1920x1080.jpg&rf=LaDigue_1920x1080.jpg&pid=hp",
		},
		{
			description:
				"考伊琴山谷的薄雾，温哥华岛，加拿大不列颠哥伦比亚省 (© Kevin Oke / Alamy)",
			id: "Default-MtPrevostDuncan",
			thumbnail:
				"https://limestart-assets.retiehe.com/wallpapers/Default-MtPrevostDuncan-Thumbnail.jpeg",
			url: "https://cn.bing.com/th?id=OHR.MtPrevostDuncan_ZH-CN2333619635_1920x1080.jpg&rf=LaDigue_1920x1080.jpg&pid=hp",
		},
		{
			description:
				"盛开的扁桃树, 加利福尼亚州，美国 (© Jeffrey Lewis / Tandem Stills + Motion)",
			id: "Default-AlmondBloom",
			thumbnail:
				"https://limestart-assets.retiehe.com/wallpapers/Default-AlmondBloom-Thumbnail.jpeg",
			url: "https://cn.bing.com/th?id=OHR.AlmondBloom_ZH-CN9441550492_1920x1080.jpg&rf=LaDigue_1920x1080.jpg&pid=hp",
		},
	],
});
